import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getNotes: builder.query({
      query: arg => {
        return {
          url: `/notes/permits/${arg.permit}/notes/`,
          method: 'GET',
          params: arg.params,
        };
      },
      providesTags: ['permitNotes'],
    }),
    addPermitNote: builder.mutation({
        query: arg => {
          return {
            url: `/notes/permits/${arg.permit}/notes/`,
            method: 'POST',
            body: arg,
          };
        },
        invalidatesTags: ['permitNotes'],
      }),
  }),
});

export const {
  useGetNotesQuery,
  useAddPermitNoteMutation,
} = api;
